export const isConsentRequired = ({ context, placement }) => {
  return context.consentModal?.placement === placement && !context.consentModalAccepted
}
